<template>
  <div id="app">
    <div class="content">
      <div class="hero">
        <p>
          I am lvwzhen, you can call me
          <span
            @click="playName()"
            class="name"
            :class="{ playing: isPlay }"
          >
            Weizhen
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 64 64"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              class="audio-icon"
            >
              <path d="M44.2 21.8a12 12 0 0 1 0 20.5" class="ani-path" />
              <path d="M50 16a20 20 0 0 1 0 32" class="ani-path-2" />
              <path d="M38 6L20 24H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12l18 18z" class="ani-path-3" />
            </svg>
          </span>.
        </p>
        <hr />
        <p>Life is short, to be a maker.</p>
        <p>
          I made some products
          <a href="https://magickpen.com/" target="_blank">MagickPen</a> ,
          <a href="https://magickimg.com/" target="_blank">magickimg</a> ,
          <a href="https://openl.io/" target="_blank">OpenL</a> ,
          <a href="https://reviewgpt.net/" target="_blank">ReviewGPT</a> ,
          <a href="https://www.teach-anything.com/" target="_blank">Teach Anything</a> ,
          <a href="https://ask2end.com/" target="_blank">Ask2End</a> ,
          <a href="https://better.avatarprompt.net/" target="_blank">BetterPrompt</a> ,
          <a href="https://law.ai2045.com/" target="_blank">AI 法律助手</a> ,
          <a href="https://sailboatui.com/" target="_blank">Sailboat UI</a> ,
          <a href="https://mi-logo.lvwzhen.com/" target="_blank">Mi Style Logo Maker</a> ,
          <a href="https://avatar.lvwzhen.com/" target="_blank">Clubhouse Avatar Maker</a> ,
          <a href="https://sspai.com/post/67375" target="_blank">极客词典</a> ,
          <a href="https://cam.lvwzhen.com/" target="_blank">小米水印生成器</a> ,
          <a href="https://food.lvwzhen.com/" target="_blank">吃货制霸地图</a> ,
          <a href="https://sharenote.app/" target="_blank">ShareNote</a> ,
          <a href="https://thuscn.com/lab" target="_blank">Thus</a> ,
          <a href="https://bio.lvwzhen.com/" target="_blank">Clubhouse Bio Maker</a> ,
          <a href="https://yuanchengke.com/" target="_blank">YuanChengKe</a> .
        </p>
        <p>
          You can find me in
          <a href="https://twitter.com/lvwzhen" target="_blank">Twitter</a> ,
          <a href="https://github.com/lvwzhen" target="_blank">GitHub</a>.
        </p>
        <p>🤟 This is The Way !</p>
        <video controls ref="audioRef" style="display:none">
          <source src="/lvwzhen.mp3" type="audio/mpeg" />
        </video>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      isPlay: false,
    };
  },
  methods: {
    playName() {
      this.$refs.audioRef.play();
      this.isPlay = true;
      setTimeout(() => {
        this.isPlay = false;
      }, 1500);
    },
  },
};
</script>

<style>
* {
  padding: 0;
  margin: 0;
}
#app {
  font-family: "Inter", sans-serif;
  color: #333;
}
.content {
  max-width: 800px;
  padding: 10vw 0 2vw 10vw;
}
hr {
  border: 0;
  height: 1px;
  background-color: #f9f9f9;
  margin: 10px 0;
}
p {
  margin: 0;
  line-height: 2.5;
}
a {
  color: #000;
}
a:hover {
  color: #f7cc5b;
  cursor: ne-resize;
}
::selection {
  background: #f7cc5b;
}
.hero {
  font-weight: bold;
  font-size: 16px;
  color: #333;
}
.name {
  cursor: help;
}
.audio-icon {
  /* cursor: help; */
  position: relative;
  top: 2px;
  width: 1rem;
  height: 1rem;
  fill: none;
  stroke: #999;
  stroke-miterlimit: 10px;
  stroke-width: 4px;
  stroke-linejoin: round;
  stroke-linecap: round;
  transition: all 0.5s cubic-bezier(0.5, 0, 0.5, 0.5) 0s;
}

.audio-icon {
  stroke: #333;
}

.playing .ani-path-3 {
  fill: #333;
}

.playing .ani-path {
  animation: audio-icon 0.6s ease-out 0.45s infinite;
}

.playing .ani-path-2 {
  animation: audio-icon 0.6s ease-in 0.1s infinite;
}

@keyframes audio-icon {
  0% {
    opacity: 0;
  }

  40% {
    opacity: 1;
  }

  60% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

@media (max-width: 800px) {
  .content {
    padding: 30px;
  }
  .audio-icon {
    display: none;
  }
  .hero {
    font-size: 18px;
    font-weight: normal;
  }
  p {
    line-height: 2;
    margin: 20px 0;
  }
}
</style>
